export default __webpack_public_path__ + "static/media/lottery-selected.cfcc724b.svg";